<script setup lang="ts">
import type { PhotoDocument } from "@kekkle/shared/types/documents/photo-document/photo-document";
import KekkleBottomSheet from "@/components/ui/KekkleBottomSheet.vue";
import Photo from "@/views/Photo.vue";

type Props = {
  photoData: PhotoDocument | null;
};

defineProps<Props>();

const open = defineModel<boolean>("open", { required: true });

const emit = defineEmits<{
  (e: "goToComments", payload: { photoId: string; groupId: string }): void;
}>();

function handleGoToComments(payload: { photoId: string; groupId: string }) {
  open.value = false;
  emit("goToComments", payload);
}
</script>

<template>
  <KekkleBottomSheet
    v-model:open="open"
    shadow="purple"
    initial-height="full"
    skip-history-cleanup
  >
    <Photo
      v-if="photoData"
      :photo-doc="photoData"
      @go-to-comments="handleGoToComments"
      @edit="open = false"
    />
  </KekkleBottomSheet>
</template>
